module.exports = __webpack_public_path__ + "files/67b201b43c0b191c078d01d68d426328.svg";